const prefix = 'core@@'
// export const WINDOW_SIZE_CHANGE = `${prefix}WINDOW_SIZE_CHANGE`
export const STORE_API_URL = `${prefix}STORE_API_URL`
export const STORE_TRANS_DATE = `${prefix}STORE_TRANS_DATE`
export const STORE_END_DATE = `${prefix}STORE_END_DATE`
export const STORE_UNITS = `${prefix}STORE_UNITS`
export const STORE_HOURS_IN_DAY = `${prefix}STORE_HOURS_IN_DAY`
export const STORE_UNIT_GROUPS = `${prefix}STORE_UNIT_GROUPS`
export const STORE_FUZZY_STR = `${prefix}STORE_FUZZY_STR`
export const STORE_FILTERED_UNIT_GROUP = `${prefix}STORE_FILTERED_UNIT_GROUP`
export const STORE_FILTERED_UNITS = `${prefix}STORE_FILTERED_UNITS`
export const STORE_ENV_CONFIG = `${prefix}STORE_ENV_CONFIG`
export const STORE_JWT = `${prefix}STORE_JWT`
// export const STORE_PJM_FUEL_TYPE = `${prefix}STORE_PJM_FUEL_TYPE`
export const STORE_COMPANY_NAME_MAP = `${prefix}STORE_COMPANY_NAME_MAP`
export const STORE_LOGIN_ERROR = `${prefix}STORE_LOGIN_ERROR`
export const STORE_2FA_REGISTRATION = `${prefix}STORE_2FA_REGISTRATION`
export const STORE_2FA_REQUIRED = `${prefix}STORE_2FA_REQUIRED`
export const STORE_2FA_OPTIONS = `${prefix}STORE_2FA_OPTIONS`
export const STORE_PJM_UNIT_CLASS = `${prefix}STORE_PJM_UNIT_CLASS`
export const STORE_UTILITY_NAME_MAP = `${prefix}STORE_UTILITY_NAME_MAP`
export const CAUSE_CODE = `${prefix}CAUSE_CODE`
export const EVENT_TYPES = `${prefix}EVENT_TYPES`
export const STATIONS = `${prefix}STATIONS`
export const UTILITY_STATIONS_MAP = `${prefix}UTILITY_STATIONS_MAP`
export const STORE_UTILITY_UNITS_MAP = `${prefix}STORE_UTILITY_UNITS_MAP`
export const STORE_UNIT_CAUSE_CODE_MAP = `${prefix}STORE_UNIT_CAUSE_CODE_MAP`
export const STORE_CAUSE_CODE_MAP = `${prefix}STORE_CAUSE_CODE_MAP`
export const STORE_CAUSE_CODE_TABLE = `${prefix}STORE_CAUSE_CODE_TABLE`
export const LOADING_UNITES = `${prefix}LOADING_UNITES`
export const STORE_UNIT_TYPE_CODE = `${prefix}STORE_UNIT_TYPE_CODE`
export const STORE_UTILITY = `${prefix}STORE_UTILITY`
export const STORE_REPORTNAME_MAP = `${prefix}STORE_REPORTNAME_MAP`
export const STORE_REPORT_DISPLAYCODE_MAP = `${prefix}STORE_REPORT_DISPLAYCODE_MAP`
export const STORE_ACTION_PEREMIT = `${prefix}STORE_ACTION_PEREMIT`
export const STORE_USER_REPORT = `${prefix}STORE_USER_REPORT`
export const STORE_USER_ROLES = `${prefix}STORE_USER_ROLES`
export const STORE_AMPLIFICATION = `${prefix}STORE_AMPLIFICATION`
export const STORE_FAILCODE = `${prefix}STORE_FAILCODE`
export const STORE_USERINFO = `${prefix}STORE_USERINFO`
export const LOADING_INIT_DATA = `${prefix}LOADING_INIT_DATA`
export const STORE_UNIT_NAME_MAP = `${prefix}STORE_UNIT_NAME_MAP`
export const STORE_ERROR = `${prefix}STORE_ERROR`
export const STORE_PNODE_ZONE_EFFECTIVE = `${prefix}STORE_PNODE_ZONE_EFFECTIVE`
export const STORE_CARD97_CONT_OP_COND = `${prefix}STORE_CARD97_CONT_OP_COND`
